import HelpIcon from '@mui/icons-material/HelpOutlineRounded';
import LogoutIcon from '@mui/icons-material/LogoutRounded';
import PaymentIcon from '@mui/icons-material/PaymentRounded';
import SettingsIcon from '@mui/icons-material/TuneRounded';

import { ACCOUNT_TYPES } from '#client/constants/accountTypes';
import * as ROUTES from '#client/constants/routes';

const USER_MENU_ITEM_IDS = {
  ACCOUNT_SETTINGS: 'account-settings',
  BILLING: 'billing',
  GET_HELP: 'get-help',
  LOG_OUT: 'log-out'
};

const USER_MENU_ITEMS = {
  [USER_MENU_ITEM_IDS.ACCOUNT_SETTINGS]: {
    icon: SettingsIcon,
    path: ROUTES.accountSettings,
    title: 'Account Settings'
  },
  [USER_MENU_ITEM_IDS.BILLING]: {
    icon: PaymentIcon,
    path: ROUTES.billingPaymentMethods,
    title: 'Billing'
  },
  [USER_MENU_ITEM_IDS.GET_HELP]: {
    icon: HelpIcon,
    path: ROUTES.help,
    title: 'Get Help'
  },
  [USER_MENU_ITEM_IDS.LOG_OUT]: {
    divider: 'top',
    icon: LogoutIcon,
    path: ROUTES.logout,
    title: 'Log Out'
  }
};

const USER_MENU_CONFIGS = {
  [ACCOUNT_TYPES.ENTERPRISE]: [USER_MENU_ITEM_IDS.LOG_OUT],
  [ACCOUNT_TYPES.STANDARD]: [
    USER_MENU_ITEM_IDS.ACCOUNT_SETTINGS,
    USER_MENU_ITEM_IDS.BILLING,
    USER_MENU_ITEM_IDS.GET_HELP,
    USER_MENU_ITEM_IDS.LOG_OUT
  ]
};

export function getUserMenuConfig(configId) {
  const menuItemIds = USER_MENU_CONFIGS[configId] ?? USER_MENU_CONFIGS[ACCOUNT_TYPES.STANDARD];

  return menuItemIds.map((itemId) => ({
    id: itemId,
    ...USER_MENU_ITEMS[itemId]
  }));
}
